import { CEFR_LEVELS, MATERIAL_TOPICS } from './learnerProfile.js'

const valuesOf = (item, key) => {
  const value = item?.[key]
  if (Array.isArray(value)) return value
  return value ? [value] : []
}

export function countBy(items, key) {
  const counts = { all: items.length }
  items.forEach(item => {
    valuesOf(item, key).forEach(value => {
      counts[value] = (counts[value] || 0) + 1
    })
  })
  return counts
}

export function filterMaterials(items, { level = 'all', topic = 'all' } = {}) {
  return items.filter(item =>
    (level === 'all' || item.cefrLevel === level) &&
    (topic === 'all' || valuesOf(item, 'topics').includes(topic))
  )
}

export function levelOptions(counts) {
  return ['all', ...CEFR_LEVELS.filter(level => counts[level] > 0)]
}

export function topicOptions(counts, interests = []) {
  const ordered = [...interests.filter(topic => MATERIAL_TOPICS.includes(topic)), ...MATERIAL_TOPICS]
  return ['all', ...new Set(ordered.filter(topic => counts[topic] > 0))]
}
